import { useEffect, useState } from 'react'

const useStaleDataFallback = <T extends unknown | null>(data: T): T => {
  const [staleData, setStaleData] = useState<T>(data)
  useEffect(() => {
    if (data) {
      setStaleData(data)
    }
  }, [data])

  return data || staleData
}

export default useStaleDataFallback
